import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        gridCardWrapper: {
            display: 'grid',
            gridTemplateColumns: '1fr',
        },
        gridWrapper: {
            display: 'grid',
            gridGap: theme.spacing(1.5),
            gridTemplateColumns: '1fr',

        },
        general: {
            gridTemplateColumns: 'repeat(3, 1fr)',
        },
        details: {
            gridTemplateColumns: '1fr',
        },
        type: {
            gridColumnStart: 1,
            gridColumnEnd: 4,
        },
        company: {
            gridColumnStart: 1,
        },
        participants: {
            gridColumnStart: 1,
        },
        changedOn: {
            gridColumnStart: 1,
        },
        followUpNeeded: {
            gridColumnStart: 1,
            gridColumnEnd: 4,
        },
        notifiedUsers: {
            gridColumnStart: 1,
        },
        attachments: {
            gridColumnStart: 3,
            gridRowStart: 2,
            gridRowEnd: 'span 4',
        },
    }
})

export default useStyles
